module.exports = __webpack_public_path__ + "/img/ChipArray-2side-FlatConcave-kLEqjR.svg";